import dynamicField from "$routes/_lib/dynamic-form-fields/dynamic-field-hoc";
import DynamicFormFields, {
  type DynamicFormFieldsProps,
  defaultFieldMap,
} from "$routes/_lib/dynamic-form-fields/dynamic-form-fields";
import React from "react";
import { useFormContext } from "react-hook-form";
import DynamicCheckboxInput from "./dynamic-checkbox-input";
import { DynamicDateInput } from "./dynamic-date-input";
import DynamicInput from "./dynamic-input";
import DynamicObjectInput from "./dynamic-object-input";

// TODO: See if we can make this a bit more specific?
function useRhfValues() {
  const { watch } = useFormContext();
  return watch();
}

// Map of property `type` in JSON Schema to React input component
// Needs to be defined here and passed down to avoid an import cycle
const defaultRhfFieldMap = {
  ...defaultFieldMap,
  object: DynamicObjectInput,
  string: DynamicInput,
  boolean: DynamicCheckboxInput,
  date: DynamicDateInput,
};

/**
 * The default mapped fields should
 * be in the common bundle as to avoid bloat
 */
const defaultRhfLazyFieldMap = {
  TextArea: dynamicField(React.lazy(() => import("$components/rhf/text-area"))),
  UnitInput: React.lazy(() => import("$components/rhf/unit-input")),
  BmiInput: React.lazy(
    () =>
      import("$routes/patient/[:patientId]/_lib/investigations/rhf-bmi-input"),
  ),
  TEWSScoreInput: React.lazy(
    () =>
      import(
        "$routes/patient/[:patientId]/_lib/investigations/tews-score-input"
      ),
  ),
};

const RhfDynamicFormFields = (
  props: Omit<DynamicFormFieldsProps, "useFormValues">,
): React.ReactElement => {
  return <DynamicFormFields useFormValues={useRhfValues} {...props} />;
};

RhfDynamicFormFields.defaultProps = {
  fieldMap: defaultRhfFieldMap,
  lazyFieldMap: defaultRhfLazyFieldMap,
};

export default RhfDynamicFormFields;
